import { useEffect, useRef, useState } from "react";
import { ICatalogoInseguro, ICatalogoInseguroDTO } from "../../../../Interfaces/hazard/IHazard";
import { ICatalogoTable } from "./CatalogoTable";
import { ISearchBox } from "@fluentui/react";
import { IPaginationV2 } from "../../../../Interfaces/base/ITable";
import { CatalogoInseguroService } from "../../../../services/hazard/catalogoInseguroService";


export const UseCatalogoTable=(props:ICatalogoTable)=>{
    const [control, setControl] = useState(true)
    const onChangeSearch = useRef<ISearchBox>(null);
    const [loading, setLoading] = useState<boolean>(false)
    const [items, setItems] = useState<ICatalogoInseguroDTO[]>([])
    const [filter, setFilter] = useState<ICatalogoInseguro>({
        skip: 0,
        take: 50,
        esCondicion: props.esCondicion
    });
    const initial: ICatalogoInseguro = {
        skip: 0,
        take: 50,
        esCondicion: props.esCondicion
      }
      const _onkeyUpSearchTable = (
        event: React.KeyboardEvent<HTMLInputElement>
      ) => {
        let { value } = event?.target as HTMLInputElement;
        setFilter({ ...filter, search: value });
      };
      const onChangeTake = (value: number) => {
        setFilter({ ...filter, take: value })
        setControl(true)
      };
      const onSkip = (value: number) => {
        const realSkip = (value * filter.take) - filter.take
        setFilter({ ...filter, skip: realSkip })
        setControl(true)
      };
      const handleResetUpdate = () => {
        setFilter(initial);
        setControl(true)
      };
      const [pagination, setPagination] = useState<IPaginationV2>({
        currentPage: 0,
        total: 0,
        pageSize: 0,
        skip: 0,
        take: 50,
        onPageChange: function (value: number): void {
        },
        onSizeChange: function (value: number): void {
        }
      })
      const getCatalogos=()=>{
        setLoading(true)
        CatalogoInseguroService.CatalogoList(filter).then((res) => {
          const pag: IPaginationV2 = {
            currentPage: res.data.page,
            total: res.data.total,
            pageSize: res.data.pages,
            onPageChange: onSkip,
            skip: filter.skip,
            take: filter.take,
            onSizeChange: onChangeTake
          };
          setPagination(pag)
          setLoading(false)
          setItems(res.data.items) 
        }).catch((e: any) => {
          setLoading(false)
        })
      }
      useEffect(() => {
        if (control) {
          getCatalogos();
          setControl(false);
        }
      }, [control, filter]);
      return {
        items,
        filter,
        setFilter,
        loading,
        pagination,
        getCatalogos,
        handleResetUpdate,
        onChangeTake,
        _onkeyUpSearchTable,
        onChangeSearch
      }
}